



























































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { FormRule } from '@/types/formRules.d.ts'
import { Cron, DialogMain } from '@/components/index'
import { cusElForm } from '@/types/form'
import { GroupPage } from '@/api/GroupAdmin'
import { defaultCron, cronToDate } from '@/utils/time'
@Component({
  components: {
    DialogMain,
    Cron,
  },
})
export default class Step2 extends Vue {
  /**
   * 表单信息
   * cron  cron
   * singleTime 单词触发时间
   * repeatCycle 重复触发周期
   * grouping 生效分群
   *    调用 /group/queryPage  分群列表
   *   form
   *    接口  id 新增第一步 id
   *          groupids 生效分群ID list
   *          cron      single时 秒 分 时 日 月 ? 年 0 10 16 27 7 ? 2020
   *
   * triggerType:
   *    触发方式（1周期重复;2定时单次）
   */
  form: any = {
    cron: '',
    triggerType: 2,
    singleTime: '',
    grouping: '',
    groupingArr: []
  };
  dialogVisible: Boolean = false;
  exeStartTime = new Date().toString();

  // 规则校验状态
  vaildSubmit(cb: Function) {
    // (this.$refs.form as cusElForm).validate((valid: boolean) => {
    //   if (valid) {
    // eslint-disable-next-line standard/no-callback-literal
    const { form } = this
    const _form = JSON.parse(JSON.stringify(form))

    if (_form.triggerType === 2) {
      _form.cron = defaultCron(form.singleTime)
    }
    _form.groupIds = [_form.grouping]
    // eslint-disable-next-line standard/no-callback-literal
    cb(true, _form)
    // } else {
    //   cb(valid)
    //   return false
    // }
    // })
  }
  created() {
    // this.getGroupPage()
    this.handleType()
  }
  async getGroupPage(objectId:any) {
    const params = {
      objectId: objectId,
      current: 0,
      size: 1000 }
    return (await GroupPage((params as any))).data
  }
  handleType() {
    const { type } = this.$route.query
    if (type === 'add') {
      this.handleAddData()
    } else {
      this.handleEditData()
    }
  }
  /**
   * 处理新增时状态数据
   */
  async handleAddData() {
    const { cardHead, objectId, objectName } = this.$route.query
    const groupingArr = await this.getGroupPage(objectId)
    this.form.groupingArr = groupingArr
    // this.form.objectId = objectId
    // this.form.objectName = objectName
  }
  /**
   * 处理编辑时状态数据
   */
  async handleEditData() {
    const { objectId, formObj, type } = this.$route.query
    const { name, code, planCategoryId, groupIds, triggerType, cron } = (formObj as any)
    const groupingArr = await this.getGroupPage(objectId)
    this.form.groupingArr = groupingArr
    this.form.grouping = groupIds[0]
    this.form.triggerType = triggerType
    // 触发方式（1周期重复;2定时单次）
    if (triggerType === 1) {
      this.form.cron = cron
    } else {
      this.form.singleTime = cronToDate(cron)
    }
    // this.form.name = name
    // this.form.code = code
    // this.form.categoryId = planCategoryId
  }
  handleClose() {
    this.dialogVisible = false
  }
}
